import React, { FC } from 'react';
import { ProductCardProps } from '../../types';
import CardBodyTopTag from './card-body-top-tag';
import CardBodyProductName from './card-body-product-name';
import CardBodyPrice from './card-body-price';
import CardBodyBottomInfo from './card-body-bottom-info';
import CardBodyMetrics from './card-body-metrics';
import ProductClaimedPriority from './product-claimed-priority';

const CardBodyVertical: FC<Partial<
  ProductCardProps & {
    productNameClass?: string;
    showRankTag?: boolean;
  }
>> = props => {
  const { productNameClass, showRankTag = true, ...rest } = props;
  return (
    <div data-role="mid-box" className="mx-2.5 my-1.5 flex flex-col gap-y-1">
      <CardBodyPrice {...rest} className="my-0" />

      <ProductClaimedPriority {...props} />

      <CardBodyTopTag {...rest} />
      <CardBodyProductName {...rest} productNameClass={productNameClass} />

      <CardBodyBottomInfo {...rest} />

      <CardBodyMetrics {...rest} />
    </div>
  );
};
export default CardBodyVertical;
